import React, { useEffect, useState } from 'react'
import AInvbasicDetail from './AInvbasicDetail'
import { Autocomplete, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, Paper, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip } from '@mui/material'
import { addInvoiceApi, getRentalInvoiceApi, getRentalInvoicePeriodApi, getRentalRateCurrency } from '../apiService'
import { globalGetService, globalPostService } from '../../../utils/globalApiServices'
import { checkApiStatus, normalizeTaxRate } from '../../../utils'
import { useSnackbar } from 'notistack'
import { NoRecordFound, PageLoader, titanAviationIntance } from '../../../shared_elements'
import { useNavigate } from 'react-router'
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import moment from "moment";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { backendDateFormat, fieldDateFormat } from "../../../constants";
import RentalUtilizationList from './RentalUtilizationList'
import { setFileUploadDetails, setUploadFiles } from '../../../shared_elements/actions'
import { useDispatch, useSelector } from 'react-redux'
import { trackActivity } from '../../../utils/mixpanel'
import WarningModal from './WarningModal'
import { getInvoiceDialogWidthProps } from './AInvItems'
import { getAdditionalTax, getTotalTax } from '..'

const AddRentalInv = ({ onToggleModal, modeType, leaseSlug, getResponseBack }) => {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const { leaseBasicDetails } = useSelector((state) => state.leases);
	const [invoice, setInvoice] = useState({is_arrears: false, is_advanced: true,});
	const { enqueueSnackbar } = useSnackbar();
	const [error, setError] = useState({});
	const [tableErrors, setTableErrors] = useState({});
	const [attachments, setAttachments] = useState([]);
	const [isLoading, setLoading] = useState(false);
	const [genratePopup, setGenratePopup] = useState(false);
	const [orignalData, setOrignalData] = useState({})
	const [periodMonthYear, setPeriodMonthYear] = useState(null);
	const [periodEnabled, setPeriodEnabled] = useState(false);
	const [periodLoading, setPeriodLoading] = useState(false);
	const [warning, setWarning] = useState({modal:false});
	const [pendingPayload, setPendingPayload] = useState(null);
	const [activeTaxList, setActiveTaxList] = useState([]);
	const [currencies, setCurrencies] = useState([]);
    const [dropDownLoader, setDropDownLoader] = useState({ currency: false });

	const getCurrencyCode = (currencyValue) => (currencyValue && typeof currencyValue === 'object' ? currencyValue.code : currencyValue) || null;

	const submitInvoice = (payload) => {
		setLoading(true);
		globalPostService(addInvoiceApi(), { ...payload })
			.then(async (response) => {
				if (checkApiStatus(response)) {
					if (attachments?.length) {
						dispatch(setUploadFiles({ modal: true, slug: response?.data?.data?.slug }));
					}
					setLoading(false);
					onToggleModal();
					getResponseBack();
					navigate(`/invoices/view/${response?.data?.data?.slug}`, { state: { from: 'viewFromLease' } })
					setPendingPayload({})
					enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
					trackActivity('Item Added', { page_title: `Add Rental Invoice`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: payload, response: response?.data })
				} else {
					setLoading(false);
					enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
					trackActivity('Item Added', { page_title: `Add Rental Invoice`, error_msg: response?.data?.message, item_id: null, payload: payload, response: response?.data })
				}
			})
	};

	const onAddEditInvoice = () => {
		let validationInputs = {
			invoice_number: invoice?.invoice_number?.trim()?.length ? '' : 'Please enter Invoice Number',
			date: invoice?.date ? '' : 'Please enter Invoice Date',
			due_date: invoice?.due_date ? '' : 'Please enter Due Date',
			currency: invoice?.currency ? '' : 'Please select Currency',
			bank: invoice?.bank ? '' : 'Please select Bank',
			from: invoice?.from?.id ? '' : 'Please select From',
			to: invoice?.to?.id ? '' : 'Please select To'
		}
		const invoiceDate = moment(invoice?.date);
		const dueDate = moment(invoice?.due_date);
		const maxAllowedDate = moment(leaseBasicDetails?.end_date).add(3, 'months');
		if (invoice?.date && invoice?.due_date) {
			if (dueDate.isBefore(invoiceDate)) {
				validationInputs.due_date = "Due date cannot be before Invoice date";
			}
			if (invoiceDate.isAfter(dueDate)) {
				validationInputs.date = "Invoice date cannot be after Due date";
			}
			if (invoiceDate.isBefore(leaseBasicDetails?.start_date)) {
				validationInputs.date = "Invoice Date cannot be before Lease Start Date";
			}
			if (invoiceDate.isAfter(maxAllowedDate)) {
				validationInputs.date = "Invoice Date must be within 3 months after the Lease End Date.";
			}
			if (dueDate.isAfter(maxAllowedDate)) {
				validationInputs.due_date = "Due Date must be within 3 months after the Lease End Date.";
			}
			if (dueDate.isBefore(leaseBasicDetails?.start_date)) {
				validationInputs.due_date = "Due Date cannot be before Lease Start Date";
			}
			if (!invoice?.is_advanced && invoiceDate.isBefore(invoice?.start_date)) {
				validationInputs.date = "Invoice Date cannot be before Period Start Date";
			}
			if (!invoice?.is_advanced && dueDate.isBefore(invoice?.start_date)) {
				validationInputs.due_date = "Due Date cannot be before Period Start Date";
			}
			if (invoice?.due_date && !dueDate.isValid()) {
                validationInputs.due_date = "Please enter valid Due Date";
            }
            if (invoice?.date &&!invoiceDate.isValid()) {
                validationInputs.date = "Please enter valid Invoice Date";
            }
		}
		setError({ ...validationInputs });

		// ----------------Item Table Condition-----------
		let newErrors = {};
		invoice.invoice_items.forEach((row, index) => {
			const errors = {};
			if (!row.invoice_item_name) {
				errors.invoice_item_name = "Please enter Invoice Item";
			}

			if (!titanAviationIntance && !row.description?.trim()) {
				errors.description = "Please enter Description";
			}

			if (Object.keys(errors).length > 0) {
				newErrors[index] = errors;
			}
		});
		setTableErrors(newErrors);
		if (!Object.keys(validationInputs).every((k) => validationInputs[k] === '') || Object.keys(newErrors).length > 0) {
			return;
		}
		let payload = Object.assign({}, invoice)

		payload = {
			invoice_number: invoice?.invoice_number || null,
			start_date: invoice?.start_date || null,
			end_date: invoice?.end_date || null,
			date: invoice?.date || null,
			due_date: invoice?.due_date || null,
			currency: invoice?.currency?.code || null,
			bank: invoice?.bank || null,
			from: invoice?.from || null,
			to: invoice?.to || null,
			invoice_type: { label: 'Rental', value: 2 },
			lease_slug: invoice?.lease_slug,
			remarks: invoice?.remarks || null,
			description: invoice?.description ? invoice?.description : null,
			footer_note : invoice?.bank?.footer_note || null,
			asset : invoice?.asset ? invoice?.asset : null,
			trustee_id : invoice?.trustee_id ? invoice?.trustee_id : null,
			invoice_items: Array.isArray(invoice?.invoice_items)
                ? invoice.invoice_items.map((items) => {
                      const subTotal = Number(items?.sub_total) || 0;
                      const taxRate = Number(items?.tax_rate) || 0;
                      const taxAmount = subTotal * (taxRate / 100);
                      const subAmountTotal = subTotal + taxAmount;
                      return {
                          invoice_item_name: items?.invoice_item_name || null,		  
				description: items?.description ? items?.description : null,
				unit_description: items?.unit_description ? items?.unit_description : null,
				no_of_units: items?.no_of_units ? items?.no_of_units : 0,
				rate_per_unit: items?.rate_per_unit ? items?.rate_per_unit : 0,
				sub_total: items?.sub_total ? items?.sub_total : 0,
				tax_rate: normalizeTaxRate(items?.tax_rate),
				tax_amount: items?.tax_amount ? Number(items?.tax_amount) : 0,
				sub_amount_total: subAmountTotal.toFixed(4),
				asset : items?.asset ? items?.asset : null,
				rental: items?.id ? items?.id : null,
				sub_reference_id: items?.id ? items?.id : null,
			};
                  })
                : [],
        };
		let updatedInvoiceItems = getAdditionalTax(payload?.invoice_items, activeTaxList)
		let tax_details = getTotalTax(payload?.invoice_items, activeTaxList)
		payload = {
			...payload,
			tax_details: tax_details,
			invoice_items: updatedInvoiceItems,
		}
		if (invoice?.has_invoice_warning) {
			setWarning({ modal: true });
			setPendingPayload({...payload,force_create:true});
		} else {
			submitInvoice(payload);
		}
	};

	const onFieldChange = (keyParam, value, invoiceItem, itemIndex) => {

		if (invoiceItem) {
			if (keyParam === "sub_total" || keyParam === "tax_rate") {
				setInvoice(prev => {
					const currentItem = prev.invoice_items[itemIndex];
					const subTotal = keyParam === "sub_total"
						? Number(value) || 0
						: Number(currentItem.sub_total) || 0;
					const taxRate = keyParam === "tax_rate"
						? Number(value) || 0
						: Number(currentItem.tax_rate) || 0;
					const taxAmount = subTotal * (taxRate / 100);
					const subAmountTotal = subTotal + taxAmount;
					return {
						...prev,
						invoice_items: prev.invoice_items.map((item, index) =>
							index !== itemIndex
								? item
								: {
									...item,
									[keyParam]: value,
									tax_amount: taxAmount.toFixed(4),
									sub_amount_total: subAmountTotal.toFixed(4),
								}
						),
					};
				});
			} else {
				setInvoice(prev => ({
					...prev,
					invoice_items: prev.invoice_items.map((item, index) =>
						index !== itemIndex ? item : { ...item, [keyParam]: value }
					),
				}));
			}
		} else {
			setInvoice(prev => {
				if (keyParam === "is_arrears") {
					return { ...prev, is_arrears: true, is_advanced: false };
				}
				if (keyParam === "is_advanced") {
					return { ...prev, is_advanced: true, is_arrears: false };
				}
				return { ...prev, [keyParam]: value };
			});
		}
	};

	const onRestErrorKey = (keyParam) => {
		setError({ ...error, [keyParam]: '' })
	}

	const handleFileChange = (files) => {
		setAttachments(files);
		dispatch(setFileUploadDetails({ attachments: files }))
	};

	const resetTableError = (rowIndex, fieldName) => {
		setTableErrors((prevErrors) => {
			const rowErrors = { ...prevErrors[rowIndex] };
			delete rowErrors[fieldName];

			const updatedErrors = { ...prevErrors };
			if (Object.keys(rowErrors).length === 0) {
				delete updatedErrors[rowIndex];
			} else {
				updatedErrors[rowIndex] = rowErrors;
			}

			return updatedErrors;
		});
	};
    
	const getRentalInvoice = () => {
		setError({});
		let validationInputs = {
			start_date: invoice?.start_date ? '' : 'Please enter Period Start Date',
			end_date: invoice?.end_date ? '' : 'Please enter Period End Date',
		}

		const startDate = moment(invoice?.start_date);
		const endDate = moment(invoice?.end_date);
		// if (invoice?.start_date && startDate.isValid() && startDate.isAfter(moment(), 'day')) {
		// 	validationInputs.start_date = "Period Start Date cannot be a future date";
		// }
		if (invoice?.start_date && invoice?.end_date) {
			if (endDate.isBefore(startDate)) {
				validationInputs.end_date = "Period End Date cannot be before Period Start Date";
			}
			if (startDate.isAfter(endDate)) {
				validationInputs.start_date = "Period Start Date cannot be after Period End Date";
			}
			if (startDate.isBefore(leaseBasicDetails?.start_date)) {
				validationInputs.start_date = "Period Start Date cannot be before Lease Start Date";
			}
			if (startDate.isAfter(leaseBasicDetails?.end_date)) {
				validationInputs.start_date = "Period Start Date cannot be after Lease End Date";
			}
			if (endDate.isAfter(leaseBasicDetails?.end_date)) {
				validationInputs.end_date = "Period End Date cannot be after Lease End Date";
			}
			if (endDate.isBefore(leaseBasicDetails?.start_date)) {
				validationInputs.end_date = "Period End Date cannot be before Lease Start Date";
			}
			if (invoice?.end_date && !endDate.isValid()) {
                validationInputs.end_date = "Please enter valid Period End Date";
            }
            if (invoice?.start_date &&!startDate.isValid()) {
                validationInputs.start_date = "Please enter valid Period Start Date";
            }
		}

		if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
			setLoading(true);
			globalGetService(getRentalInvoiceApi({ lease_slug: leaseSlug, period_start_date: invoice?.start_date, period_end_date: invoice?.end_date, is_arrears:invoice?.is_arrears, is_advanced:invoice?.is_advanced, currency: getCurrencyCode(invoice?.currency) }))
				.then(response => {
					setLoading(false);
					if (checkApiStatus(response)) {
						setInvoice({...response?.data?.data, is_advanced: invoice?.is_advanced, is_arrears: invoice?.is_arrears});
						setOrignalData(response?.data?.data);
						if (response?.data?.data?.masters?.length === 1 ) {
							getRentalDetails(response?.data?.data?.masters?.map(item => item.master_slug))
						}
						if (response?.data?.data?.is_invoice === false) {
							setGenratePopup(false)
						} else {
							setGenratePopup(true)
						}
						enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
						trackActivity('Item Added', { page_title: `Add Rental Invoice`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: invoice, response: response?.data, })
					} else {
						enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
						trackActivity('Item Added', { page_title: `Add Rental Invoice`, error_msg: response?.data?.message, item_id: null, payload: invoice, response: response?.data })
					}
				});
		} else {
			setError({ ...validationInputs, });
			trackActivity(`Item Added`, { page_title: `Add Rental Invoice`, error_msg: validationInputs, })
		}
	};

	const getRentalDetails = (master_slug) => {
		setLoading(true);
		globalGetService(getRentalInvoiceApi({ lease_slug: leaseSlug, period_start_date: invoice?.start_date, period_end_date: invoice?.end_date, master_slug: master_slug, is_arrears:true, is_advanced:invoice?.is_advanced, currency: getCurrencyCode(invoice?.currency) }))
			.then(response => {
				setLoading(false);
				if (checkApiStatus(response)) {
					setInvoice({...response?.data?.data, is_advanced: invoice?.is_advanced, is_arrears: invoice?.is_arrears});
					if (response?.data?.data?.is_invoice === false) {
							setGenratePopup(false)
						} else {
							setGenratePopup(true)
						}
					enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
				} else {
					enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
				}
			});
	}

	const getCurrencies = () => {
		setDropDownLoader(prev => ({ ...prev, currency: true }));
		globalGetService(getRentalRateCurrency({lease_slug: leaseSlug}))
			.then(response => {
				if (checkApiStatus(response)) {
					setCurrencies(response?.data?.data?.currencies || []);
				}
				setDropDownLoader(prev => ({ ...prev, currency: false }));
			});
	};

	useEffect(() => {
		if (leaseSlug) {
			getCurrencies();
		}
	}, [leaseSlug]);

	useEffect(() => {
		if (currencies?.length && !getCurrencyCode(invoice?.currency)) {
			const usdCurrency = currencies.find(c => c.code === 'USD' || c.name === 'US Dollar');
			if (usdCurrency) {
				setInvoice(prev => ({ ...prev, currency: usdCurrency.code }));
			}
		}
	}, [currencies]);

	const isDataChanged = () => {
		const originalInvoiceData = orignalData || {};
		return (
			invoice?.start_date !== originalInvoiceData?.start_date ||
			invoice?.end_date !== originalInvoiceData?.end_date
		);
	};

	useEffect(() => {
		const isValidStart = moment( invoice?.start_date, backendDateFormat, true ).isValid();
		const isValidEnd = moment( invoice?.end_date, backendDateFormat, true ).isValid();
		if (!isValidStart || !isValidEnd) return;

		const timer = setTimeout(() => {
			if (isDataChanged()) {
				if (invoice?.masters?.length === 1) {
					getRentalDetails(invoice?.masters[0]?.master_slug);
				} else if (invoice?.masters?.length > 1) {
					getRentalInvoice();
				}
			}
		}, 1100);

		return () => clearTimeout(timer);
	}, [invoice?.start_date, invoice?.end_date]);

	const handleItemClicked = (page_type) => {
		trackActivity('Item Clicked', { page_title: `Add Rental Invoice`, page_type: page_type, })
	}

	const getRentalInvoicePeriod = (date) => {
		const month = moment(date).month() + 1;
		const year = moment(date).year();
		setError(prev => ({ ...prev, start_date: '', end_date: '' }));
		setPeriodLoading(true);
		globalGetService(getRentalInvoicePeriodApi({ lease_slug: leaseSlug, month, year }))
			.then(response => {
				setPeriodLoading(false);
				if (checkApiStatus(response)) {
					const { start_date, end_date } = response?.data?.data || {};
					onFieldChange("start_date", start_date || null);
					onFieldChange("end_date", end_date || null);
					setPeriodEnabled(true);
					enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
				} else {
					enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
				}
			});
	};
    
	return (
		<>
			<Dialog aria-labelledby="customized-dialog-title" className='add-lease-dialog' fullWidth open={true} style={{overflowY:"unset"}} {...(invoice?.masters?.length > 0 ? { maxWidth: "sm" } : !genratePopup ? { maxWidth: "xs" } : getInvoiceDialogWidthProps({ invoice: { ...invoice, invoice_type: { label: 'Rental', value: 2 } }, type: 'rentalInvoice', activeTaxList }, 'xl'))} >
				<DialogTitle sx={{ m: 0, p: 2, pl:3 }} className='dialog-header' id="customized-dialog-title"> 
					Add Rental Invoice
				</DialogTitle>
				<DialogContent dividers>
					{!genratePopup || invoice?.masters?.length > 1 ? <Grid container spacing={2}>
						{invoice?.is_invoice !== false ? <Grid size={{ md: 6, xs: 12 }}>
							<LocalizationProvider dateAdapter={AdapterMoment}>
								<DatePicker
									label="Invoice Period (Month & Year)"
									views={['month', 'year']}
									openTo="month"
									value={periodMonthYear}
									disabled={periodLoading}
									minDate={leaseBasicDetails?.start_date ? moment(leaseBasicDetails.start_date) : undefined}
									maxDate={leaseBasicDetails?.end_date ? moment(leaseBasicDetails.end_date) : undefined}
									shouldDisableYear={(year) => {
										const leaseStart = leaseBasicDetails?.start_date ? moment(leaseBasicDetails.start_date) : null;
										const leaseEnd = leaseBasicDetails?.end_date ? moment(leaseBasicDetails.end_date) : null;
										if (!leaseStart || !leaseEnd) return false;
										return year.year() < leaseStart.year() || year.year() > leaseEnd.year();
									}}
									shouldDisableMonth={(month) => {
										const leaseStart = leaseBasicDetails?.start_date ? moment(leaseBasicDetails.start_date) : null;
										const leaseEnd = leaseBasicDetails?.end_date ? moment(leaseBasicDetails.end_date) : null;
										if (!leaseStart || !leaseEnd) return false;
										return month.isBefore(leaseStart, 'month') || month.isAfter(leaseEnd, 'month');
									}}
									onChange={(date) => {
										setPeriodEnabled(false);
										onFieldChange("start_date", null);
										onFieldChange("end_date", null);
										if (date && moment(date).isValid()) {
											const leaseStart = leaseBasicDetails?.start_date ? moment(leaseBasicDetails.start_date) : null;
											const leaseEnd = leaseBasicDetails?.end_date ? moment(leaseBasicDetails.end_date) : null;
											const isWithinLease = (!leaseStart || !date.isBefore(leaseStart, 'month')) &&
												(!leaseEnd || !date.isAfter(leaseEnd, 'month'));
											if (isWithinLease) {
												setError(prev => ({ ...prev, periodMonthYear: '' }));
												setPeriodMonthYear(date);
												getRentalInvoicePeriod(date);
											} else {
												setError(prev => ({ ...prev, periodMonthYear: 'Please enter Invoice Period within Lease Duration' }));
											}
										}
									}}
									slotProps={{
										textField: {
											InputLabelProps: { shrink: true },
											size: "small",
											margin: "normal",
											error: !!error?.periodMonthYear,
											helperText: error?.periodMonthYear || '',
											InputProps: periodLoading ? {
												endAdornment: <CircularProgress size={18} />,
											} : undefined,
										},
										field: {
											clearable: true,
											onClear: () => {
												setPeriodMonthYear(null);
												setPeriodEnabled(false);
												onFieldChange("start_date", null);
												onFieldChange("end_date", null);
												setError(prev => ({ ...prev, periodMonthYear: '' }));
											},
										}
									}}
									sx={{ width: "100%" }}
									format="MM/YYYY"
								/>
							</LocalizationProvider>
						</Grid> : null }
						<Grid size={{ md: 6, xs: 12 }}>
							<Autocomplete
								disablePortal
								disableClearable
								disabled={dropDownLoader.currency}
								options={currencies}
								value={currencies.find(c => c.code === getCurrencyCode(invoice?.currency)) || null}
								noOptionsText={dropDownLoader.currency ? "Loading..." : "No Currency Available"}
								getOptionLabel={(option) => option?.name || ""}
								onFocus={() => setError(prev => ({ ...prev, currency: "" }))}
								onChange={(e, newValue) => {
									onFieldChange('currency', newValue?.code || null);
									if (newValue?.code) {
										onRestErrorKey('currency');
									}
								}}
								isOptionEqualToValue={(option, value) => option.code === value.code}
								renderInput={(params) => {
									const selectedLabel = params?.inputProps?.value || "";
									return (
										<Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow>
											<TextField
												{...params}
												label="Currency"
												margin='normal'
												size='small'
												error={Boolean(error.currency)}
												helperText={error.currency}
												slotProps={{
													inputLabel: { shrink: true },
													input: {
														...params?.InputProps,
														endAdornment: (
															<>
																{dropDownLoader?.currency ? <CircularProgress color="inherit" size={20} /> : null}
																{params?.InputProps?.endAdornment}
															</>
														)
													}
												}}
											/>
										</Tooltip>
									);
								}}
							/>
						</Grid>
						<Grid size={{ md: invoice?.is_invoice === false ? 6 : 6, xs: 12 }}>
							<LocalizationProvider dateAdapter={AdapterMoment}>
								<DatePicker
									label="Period Start Date"
									disabled={!periodEnabled}
									value={invoice?.start_date ? moment(invoice.start_date) : null}
									minDate={leaseBasicDetails?.start_date ? moment(leaseBasicDetails.start_date) : undefined}
									maxDate={leaseBasicDetails?.end_date ? moment(leaseBasicDetails.end_date) : undefined}
									onChange={(data) => {
										const isValid = moment(data)?.isValid();
										onFieldChange("start_date", data ? moment(data).format(backendDateFormat) : null);
										if (isValid) {
											onRestErrorKey("start_date");
										}
									}}
									slotProps={{
										textField: {
											required: true,
											InputLabelProps: { shrink: true },
											size: "small",
											margin: "normal",
											error: error.start_date || false,
											helperText: error.start_date || '',
											onFocus: () => {
												if (error.start_date) {
													onRestErrorKey("start_date");
												}
											}
										},
										field: {
											clearable: true,
											onClear: () => {
												onFieldChange("start_date", null);
												onRestErrorKey("start_date");
											}
										}
									}}
									sx={{ width: "100%" }}
									format={fieldDateFormat}
								/>
							</LocalizationProvider>
						</Grid>
						<Grid size={{ md: invoice?.is_invoice === false ? 6 : 6, xs: 12 }}>
							<LocalizationProvider dateAdapter={AdapterMoment}>
								<DatePicker
									label="Period End Date"
									disabled={!periodEnabled}
									value={invoice?.end_date ? moment(invoice.end_date) : null}
									minDate={leaseBasicDetails?.start_date ? moment(leaseBasicDetails.start_date) : undefined}
									maxDate={leaseBasicDetails?.end_date ? moment(leaseBasicDetails.end_date) : undefined}
									onChange={(data) => {
										const isValid = moment(data)?.isValid();
										onFieldChange("end_date", data ? moment(data).format(backendDateFormat) : null);
										if (isValid) {
											onRestErrorKey("end_date");
										}
									}}
									slotProps={{
										textField: {
											required: true,
											InputLabelProps: { shrink: true },
											size: "small",
											margin: "normal",
											error: error.end_date || false,
											helperText: error.end_date || '',
											onFocus: () => {
												if (error.end_date) {
													onRestErrorKey("end_date");
												}
											}
										},
										field: {
											clearable: true,
											onClear: () => {
												onFieldChange("end_date", null);
												onRestErrorKey("end_date");
											}
										}
									}}
									sx={{ width: "100%" }}
									format={fieldDateFormat}
								/>
							</LocalizationProvider>
						</Grid>
						{invoice?.masters?.length > 0 ? null : <Grid item md={12} xs={12}>
							<FormControl>
								<RadioGroup row className='radio-color' >
									<FormControlLabel value="is_advanced" control={ <Radio size="small" sx={{maxHeight:"10px"}} checked={invoice?.is_advanced === true} onChange={() => onFieldChange("is_advanced")} /> } label="Advanced" />	
									<FormControlLabel value="is_arrears" control={ <Radio size="small" sx={{maxHeight:"10px"}} checked={invoice?.is_arrears === true} onChange={() => onFieldChange("is_arrears")} /> } label="Arrears" />								
								</RadioGroup>
							</FormControl>
						</Grid>}
						{invoice?.masters?.length > 0 ? (
							<Grid item size={{ md: 12, xs: 12 }}>
								<TableContainer className="lease-detail-table" component={Paper} sx={{ maxHeight: 200, overflowX: "auto" }}>
									<Table stickyHeader className="mui-table-format">
										<TableHead>
											<TableRow>
												<TableCell sx={{ minWidth: '190px' }}> Period</TableCell>
												<TableCell sx={{ minWidth: '140px' }}> Asset Name</TableCell>
												<TableCell sx={{ minWidth: '160px' }}> Utilization Type</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{invoice?.masters?.length > 0 ? invoice?.masters?.map((item, index) =>
												<RentalUtilizationList key={index} item={item} leaseSlug={leaseSlug} handleItemClicked={handleItemClicked} />
											)
												:
												<NoRecordFound />
											}
										</TableBody>
									</Table>
								</TableContainer>
								<span style={{ fontSize: '11px', background: "#ffff96", }} className='files-upload-limit' > <b>Note</b> : Your Rental Invoice is based upon Utlization.So Kindly choose a date within the Utilization period mentioned in the listing to proceed.</span>
							</Grid>
						) : null}
					</Grid> :
						<Grid container spacing={2}>
							<AInvbasicDetail addEditInvoice={invoice} type={'rentalInvoice'} modeType={modeType} onFieldChange={onFieldChange} onRestErrorKey={onRestErrorKey} invoice={{...invoice,invoice_type: { label: 'Rental', value: 2 },}} error={error} handleFileChange={handleFileChange} tableErrors={tableErrors} resetTableError={resetTableError} leaseSlug={leaseSlug} onActiveTaxLoad={setActiveTaxList}/>
						</Grid>}
				</DialogContent>
				<DialogActions sx={{ marginRight: "15px" }}>
					<Button className='cancel-btn' variant='outlined' size='small' disabled={isLoading} onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }} > Cancel </Button>
					{!genratePopup || invoice?.is_invoice === false ? <Button variant='contained' disabled={!invoice?.start_date || !invoice?.end_date || (invoice?.masters?.length > 0 && !isDataChanged())} className='btn-primary' size='small' onClick={() => { getRentalInvoice(); handleItemClicked('Proceed Button') }}>
						{isLoading ? <CircularProgress color='inherit' size={25} /> : "Proceed"}
					</Button> :
						<Button variant='contained' className='btn-primary' size='small' onClick={() => { onAddEditInvoice(); handleItemClicked('Save Button') }}>
							{isLoading ? <CircularProgress color='inherit' size={25} /> : "Save"}
						</Button>}
				</DialogActions>
			</Dialog>
			{warning.modal && <WarningModal invoice={invoice} warning={warning} onToggleModal={() => setWarning({ modal: false })} onProceed={() => submitInvoice(pendingPayload)} isLoading={isLoading} />}
			
			{isLoading ? <PageLoader /> : null}
		</>
	)
}

export default AddRentalInv